import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _21mpIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"21mp"} ref={ref}/>
});

_21mpIcon.displayName = "_21mpIcon";
